// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".incentive-pendant[data-v-577a71f2] {\n  position: relative;\n  display: inline-block;\n  width: 15.4589vw;\n  height: 15.4589vw;\n}\n.incentive-pendant-image[data-v-577a71f2] {\n  width: 100%;\n  height: 100%;\n}\n.incentive-pendant-close[data-v-577a71f2] {\n  position: absolute;\n  top: -2.8986vw;\n  right: -2.8986vw;\n  width: 4.3478vw;\n  height: 4.3478vw;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
